import { Input } from '~/components/ui/input'
import { cn } from '~/lib/utils'
import {
    ASSESSMENT_TYPE_OPTIONS,
    CLASSIFICATION_OPTIONS,
    DATA_TYPE_OPTIONS,
    SCALE_OPTIONS,
    type FieldKey,
    type SectionProps,
} from './constants'
import { Field, InputField, SelectField, Textarea } from './controls'

// 기본 식별 정보: 제목·분류·규모·평가유형·데이터타입·파트·항목번호·업종·배점·
// 대/중분류. 배점은 항목번호·업종과 같은 2열 그리드에 놓여 함께 추출한다.
export function ItemBasicForm({
    form,
    set,
    isDirty,
    errors,
}: SectionProps & {
    errors: Partial<Record<FieldKey, string>>
}) {
    return (
        <>
            {/* 제목(긴 텍스트) */}
            <Field
                label='제목'
                required
                dirty={isDirty('title')}
                error={errors.title}>
                {(control) => (
                    <Textarea
                        {...control}
                        rows={3}
                        value={form.title}
                        dirty={isDirty('title')}
                        onChange={(v) => set('title', v)}
                    />
                )}
            </Field>

            {/* 분류·규모·평가유형·데이터타입 (Select 2열, 모바일 1열) */}
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                <Field
                    label='분류'
                    required
                    dirty={isDirty('classification')}
                    error={errors.classification}>
                    {(control) => (
                        <SelectField
                            {...control}
                            options={CLASSIFICATION_OPTIONS}
                            value={form.classification}
                            dirty={isDirty('classification')}
                            onChange={(v) => set('classification', v)}
                        />
                    )}
                </Field>
                <Field
                    label='규모'
                    required
                    dirty={isDirty('scale')}
                    error={errors.scale}>
                    {(control) => (
                        <SelectField
                            {...control}
                            options={SCALE_OPTIONS}
                            value={form.scale}
                            dirty={isDirty('scale')}
                            onChange={(v) => set('scale', v)}
                        />
                    )}
                </Field>
                <Field label='평가 유형' dirty={isDirty('assessmentType')}>
                    {(control) => (
                        <SelectField
                            {...control}
                            options={ASSESSMENT_TYPE_OPTIONS}
                            value={form.assessmentType}
                            dirty={isDirty('assessmentType')}
                            onChange={(v) => set('assessmentType', v)}
                        />
                    )}
                </Field>
                <Field label='데이터 타입' dirty={isDirty('dataType')}>
                    {(control) => (
                        <SelectField
                            {...control}
                            options={DATA_TYPE_OPTIONS}
                            value={form.dataType}
                            dirty={isDirty('dataType')}
                            onChange={(v) => set('dataType', v)}
                        />
                    )}
                </Field>
            </div>

            {/* 파트·항목번호·업종 (input) + 배점(number) (모바일 1열) */}
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                <Field
                    label='파트'
                    required
                    dirty={isDirty('part')}
                    error={errors.part}>
                    {(control) => (
                        <InputField
                            {...control}
                            value={form.part}
                            dirty={isDirty('part')}
                            onChange={(v) => set('part', v)}
                        />
                    )}
                </Field>
                <Field label='항목번호' dirty={isDirty('itemNumber')}>
                    {(control) => (
                        <InputField
                            {...control}
                            value={form.itemNumber}
                            dirty={isDirty('itemNumber')}
                            onChange={(v) => set('itemNumber', v)}
                        />
                    )}
                </Field>
                <Field label='업종' dirty={isDirty('industry')}>
                    {(control) => (
                        <InputField
                            {...control}
                            value={form.industry}
                            dirty={isDirty('industry')}
                            onChange={(v) => set('industry', v)}
                        />
                    )}
                </Field>
                <Field
                    label='배점 (채점 반영)'
                    required
                    dirty={isDirty('maxScore')}
                    error={errors.maxScore}>
                    {(control) => (
                        <Input
                            {...control}
                            type='number'
                            value={form.maxScore ?? ''}
                            onChange={(e) =>
                                set(
                                    'maxScore',
                                    e.target.value === ''
                                        ? null
                                        : Number(e.target.value)
                                )
                            }
                            className={cn(
                                isDirty('maxScore') &&
                                    'border-primary ring-primary/30 ring-2'
                            )}
                        />
                    )}
                </Field>
            </div>

            {/* 대분류·중분류 (input) (모바일 1열) */}
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                <Field label='대분류' dirty={isDirty('majorCategory')}>
                    {(control) => (
                        <InputField
                            {...control}
                            value={form.majorCategory}
                            dirty={isDirty('majorCategory')}
                            onChange={(v) => set('majorCategory', v)}
                        />
                    )}
                </Field>
                <Field label='중분류' dirty={isDirty('middleCategory')}>
                    {(control) => (
                        <InputField
                            {...control}
                            value={form.middleCategory}
                            dirty={isDirty('middleCategory')}
                            onChange={(v) => set('middleCategory', v)}
                        />
                    )}
                </Field>
            </div>
        </>
    )
}
